/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/trusted-devices/${encodeURIComponent(request.path['deviceId'] as any)}/verify`,
    // @ts-ignore for sm-axios
    urlTemplate: '/trusted-devices/{deviceId}/verify',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Verify a signed challenge nonce for a registered trusted device. Forwards to authx-auth-api with the email extracted from the token in the request body.
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  path: {
    deviceId: string
  }
  body: {
    /**
     * JWT issued by login-beef. The user email is extracted from it.
     */
    token: string
    /**
     * UUID identifying the challenge being verified.
     */
    challengeId: string
    /**
     * Base64url-encoded signature of the challenge nonce, produced with the trusted device's private key.
     */
    signature: string
    /**
     * Device token to save against the user so that subsequent logins can skip MFA.
     */
    userDeviceToken: string
  }
}

export interface Response {
  /**
   * Confirms that the challenge signature was verified successfully.
   */
  status: 'confirmed'
}

